import React from 'react'
import BoldCheckbox from './BoldCheckbox'

interface AgreementItemProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label: string
  text: string
  onViewClick?: () => void
}

const AgreementItem: React.FC<AgreementItemProps> = ({
  checked,
  onChange,
  label,
  text,
  onViewClick,
}) => {
  const handleTextClick = () => {
    onChange(!checked)
  }

  const handleViewClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (onViewClick) {
      onViewClick()
    }
  }

  return (
    <div className="flex items-center gap-16px">
      <div
        className="flex-1 flex items-center gap-16px cursor-pointer pl-8px py-10px"
        onClick={handleTextClick}
      >
        <BoldCheckbox checked={checked} onChange={onChange} size={20} />
        <span className="font-pretendard font-bold text-16px leading-20px text-brown-80%-main text-left whitespace-nowrap">
          {label}
        </span>
        <span className="font-pretendard font-regular text-16px leading-20px text-brown-80%-main text-left">
          {text}
        </span>
      </div>

      {onViewClick && (
        <button
          type="button"
          className={`
            flex items-center justify-center cursor-pointer active:opacity-70 px-8px py-8px
            font-pretendard font-regular text-14px leading-20px text-brown-80%-main underline
          `}
          onClick={handleViewClick}
        >
          보기
        </button>
      )}
    </div>
  )
}

export default AgreementItem
